import { isPlatformBrowser } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Component, Inject, Optional, PLATFORM_ID } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import readXlsxFile from 'read-excel-file';
import { firstValueFrom } from 'rxjs';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { StoreImportModel } from 'src/app/models/imports/store-import-model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { StoreService } from 'src/app/services/archive/store.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-import-store',
  templateUrl: './import-store.component.html',
  styleUrls: ['./import-store.component.scss'],
  standalone: false
})
export class ImportStoreComponent {

  errorStore: number = 0;
  eventFile: any;
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  storeAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  storeImport: boolean = false;
  nameFile: string = '';
  visibleTxt: boolean = false;

  constructor(
    private storeService: StoreService,
    public config: DynamicDialogConfig,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef,
    @Inject(PLATFORM_ID) private platformId: object) { }

  attachFileImport() {
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('fileImport')?.click();
    }
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      if (isPlatformBrowser(this.platformId)) {
        this.eventFile.target.value = '';
      }
    }
  }

  downloadGuideImport() {
    this.storeService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaBodegas.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  downloadErrorsTxt() {
    if (!this.storeAlerts || this.storeAlerts.length === 0) {
      this.toastHandlerService.showToast(
        'error',
        'No hay alertas para exportar'
      );
      return;
    }

    this.storeService.exportImportErrors(this.storeAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionBodegas_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast(
          'error',
          'Error al exportar el archivo'
        );
      }
    });
  }

  close() {
    const data: ModalObjectType = {};
    if (this.storeImport) {
      data.params = { reload: true };
      this.ref.close(data);
    } else {
      data.params = { reload: false };
      this.ref.close(data);
    }
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  importStores() {
    this.storeAlerts = [];
    this.errorStore = 0;
    this.visibleTxt = false;
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (!isPlatformBrowser(this.platformId)) return;
    let isOk: boolean = true;
    const input = document.getElementById("fileImport") as any;
    const rowsImports = new Array<StoreImportModel>();
    let row: StoreImportModel;
    let counter: number = 1, branchCode: number, code: number, alterCode: string | null, name: string, costCenterCode: string, inventoryCode: number,
      isActive: boolean, isOwned: boolean, occupancyPercentage: boolean;
    if (!input.files[0]) {
      this.toastHandlerService.showToast(
        'error',
        'No ha seleccionado ningún archivo.'
      );
      return;
    }
    readXlsxFile(input.files[0]).then(async (rows) => {
      if (rows.length <= 1) {
        this.toastHandlerService.showToast(
          'error',
          'El archivo ingresado no tiene registros para importar.'
        );
        return;
      }
      rows.splice(0, 1);
      rows.forEach(element => {
        counter = counter + 1;
        let rowHasError = false;

        //A. Código Sucursal:
        branchCode = parseFloat(element[0] as string);
        if (isNaN(branchCode)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}. El código de la sucursal no es válido.`;
          this.storeAlerts.push(alert);
          rowHasError = true;
        }

        //B. Código:
        code = parseFloat(element[1] as string);
        if (element[1] == null || element[1].toString().trim() === '' || isNaN(code)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}. El código no es válido.`;
          this.storeAlerts.push(alert);
          rowHasError = true;
        }

        //C. Código Alterno:
        alterCode = element[2] as string;
        if (alterCode != null) {
          if (alterCode.length > 10) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}. El código alterno supera el tamaño máximo de caracteres (10).`;
            this.storeAlerts.push(alert);
            rowHasError = true;
          }
        }

        //D. Nombre Bodega:
        name = element[3] as string;
        if (name == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}. El nombre no es válido.`;
          this.storeAlerts.push(alert);
          rowHasError = true;
        } else if (name.length > 50) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}. El nombre supera el tamaño máximo de caracteres (50).`;
          this.storeAlerts.push(alert);
          rowHasError = true;
        }

        //E. Centro de Costos:
        costCenterCode = element[4] as string;
        if (costCenterCode != null) {
          if (costCenterCode.length > 10) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}. El código centro de costos supera el tamaño máximo de caracteres (10).`;
            this.storeAlerts.push(alert);
            rowHasError = true;
          }
        }

        //F. Inventario:
        const valueInventoryCode = element[5];
        if (valueInventoryCode == null || valueInventoryCode === "") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna F. El código del inventario no es válido.`;
          this.storeAlerts.push(alert);
          rowHasError = true;
        }
        inventoryCode = Number(valueInventoryCode);
        if (isNaN(inventoryCode)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna F. El código del inventario no es válido.`;
          this.storeAlerts.push(alert);
          rowHasError = true;
        }

        // G. Activo:
        if (element[6] as string != "S" && element[6] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}. El campo Activo debe tener valores como: S / N.`;
          this.storeAlerts.push(alert);
          rowHasError = true;
        }
        isActive = element[6] as string === "S" ? true : false

        // H. Propio:
        if (element[7] as string != "S" && element[7] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}. El campo Propio debe tener valores como: S / N.`;
          this.storeAlerts.push(alert);
          rowHasError = true;
        }
        isOwned = element[7] as string === "S" ? true : false

        // I. % Ocupación:
        if (element[8] as string != "S" && element[8] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}. El campo % Ocupación debe ser valores como: S / N.`;
          this.storeAlerts.push(alert);
          rowHasError = true;
        }
        occupancyPercentage = element[8] as string === "S" ? true : false

        if (!rowHasError) {
          row = new StoreImportModel(counter, branchCode, code, alterCode, name, costCenterCode, inventoryCode,
            isActive, isOwned, occupancyPercentage);
          rowsImports.push(row);
        } else {
          isOk = false;
        }
      });

      if (!isOk || rowsImports.length === 0) {
        this.errorStore = 1;
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con errores, puede exportarlos si lo desea'
        );
        return;
      }

      await this.processImportStores(rowsImports);
    });
  }

  async processImportStores(rowsImports: Array<StoreImportModel>) {
    try {
      const response = await firstValueFrom(this.storeService.importProviders(rowsImports));
      this.loadPreInvoicingModel = response;
      this.storeAlerts = response?.alerts ?? [];
      this.errorStore = response?.preInvoicingStateId;

      if (this.errorStore === 1) {
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con errores, puede exportarlos si lo desea.',
          'ERROR'
        );
      } else if (this.storeAlerts.length > 0) {
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con alertas, puede exportarlas si lo desea'
        );
      } else {
        this.visibleTxt = false;
        this.storeImport = true;
        this.toastHandlerService.showToast(
          'success',
          `La importación terminó exitosamente.`
        );
        this.close();
      }
      this.clearInputFile();
    } catch (error) {
      this.nameFile = 'Ningún archivo seleccionado.';
      console.error('Error al importar Bodegas.', error);
    }
  }
}
